import { render, staticRenderFns } from "./CommonDropzoneWithAxios.vue?vue&type=template&id=5224beb3&lang=pug&"
import script from "./CommonDropzoneWithAxios.vue?vue&type=script&lang=ts&"
export * from "./CommonDropzoneWithAxios.vue?vue&type=script&lang=ts&"
import style0 from "./CommonDropzoneWithAxios.vue?vue&type=style&index=0&id=5224beb3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports